var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sideblock-delivery"},[_c('div',{staticClass:"sideblock-delivery__body"},[_c('common-fitting-info')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }